exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".dropdown-menu{border:0;border-radius:0}.dropdown-item{color:#fff}", "", {"version":3,"sources":["D:/app/gocode/src/gitlab.com/satit13/VillageService/ui/src/components/header.vue"],"names":[],"mappings":"AACA,eACE,SAAY,AACZ,eAAmB,CACpB,AACD,eACE,UAAY,CACb","file":"header.vue","sourcesContent":["\n.dropdown-menu {\r\n  border: 0px;\r\n  border-radius: 0px;\n}\n.dropdown-item {\r\n  color: #fff;\n}\r\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-72cb4ad3","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/header.vue
// module id = 301
// module chunks = 4